/* F3 qibla: great-circle bearing to Al-Masjid al-Haram, the dial, and the
   scroll-driven globe. Ported from the approved design. Needs three.js. */
(function(){
  'use strict';
  var root = document.documentElement;
/* ── great-circle maths ────────────────────────────────────────────── */
  var KAABA = { lat: 21.4225, lon: 39.8262 };
  var ATL   = { lat: 33.7490, lon: -84.3880, name: 'Atlanta, Georgia' };
  var R = 6371;
  var rad = function(d){ return d * Math.PI / 180; };
  var deg = function(r){ return r * 180 / Math.PI; };

  function bearing(from, to){
    var f1 = rad(from.lat), f2 = rad(to.lat), dl = rad(to.lon - from.lon);
    var y = Math.sin(dl) * Math.cos(f2);
    var x = Math.cos(f1) * Math.sin(f2) - Math.sin(f1) * Math.cos(f2) * Math.cos(dl);
    return (deg(Math.atan2(y, x)) + 360) % 360;
  }
  function distance(from, to){
    var f1 = rad(from.lat), f2 = rad(to.lat);
    var df = rad(to.lat - from.lat), dl = rad(to.lon - from.lon);
    var a = Math.sin(df/2)*Math.sin(df/2) + Math.cos(f1)*Math.cos(f2)*Math.sin(dl/2)*Math.sin(dl/2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  }
/* ── the dial, drawn in the idiom of the Golden Point seal ─────────── */
  var C = 210, dialEl = document.getElementById('dial');
  var state = { origin: ATL, bearingDeg: 0 };

  function css(v){ return getComputedStyle(root).getPropertyValue(v).trim(); }

  function drawDial(){
    var gold = css('--accent'), rule = css('--rule-strong'),
        text = css('--text'), faint = css('--text-3');
    var s = [];
    s.push('<svg viewBox="0 0 420 420" role="img" aria-label="Qibla dial: bearing '
           + state.bearingDeg.toFixed(1) + ' degrees true to Al-Masjid al-Haram">');

    // concentric rings
    [200, 192, 158, 96].forEach(function(r, i){
      s.push('<circle cx="210" cy="210" r="' + r + '" fill="none" stroke="'
             + (i < 2 ? gold : rule) + '" stroke-width="' + (i === 0 ? 1.4 : 0.8) + '"/>');
    });

    // radial graticule every 15 degrees, longer ticks on the cardinals
    for (var a = 0; a < 360; a += 15){
      var t = rad(a - 90), major = a % 90 === 0, mid = a % 45 === 0;
      var r0 = major ? 96 : (mid ? 140 : 168), r1 = 192;
      s.push('<line x1="' + (C + r0*Math.cos(t)).toFixed(1) + '" y1="' + (C + r0*Math.sin(t)).toFixed(1)
           + '" x2="' + (C + r1*Math.cos(t)).toFixed(1) + '" y2="' + (C + r1*Math.sin(t)).toFixed(1)
           + '" stroke="' + (major ? gold : rule) + '" stroke-width="' + (major ? 0.9 : 0.5)
           + '" opacity="' + (major ? 1 : 0.75) + '"/>');
    }

    // cardinal letters
    [['N',0],['E',90],['S',180],['W',270]].forEach(function(p){
      var t = rad(p[1] - 90);
      s.push('<text x="' + (C + 178*Math.cos(t)).toFixed(1) + '" y="' + (C + 178*Math.sin(t)).toFixed(1)
           + '" fill="' + faint + '" font-family="Jost,sans-serif" font-size="13" font-weight="300"'
           + ' letter-spacing="1" text-anchor="middle" dominant-baseline="central">' + p[0] + '</text>');
    });

    // the needle — a long gold spine to Makkah, short counterweight behind
    s.push('<g class="needle" id="needle" style="transform:rotate(' + state.bearingDeg.toFixed(2) + 'deg)">');
    s.push('<line x1="210" y1="240" x2="210" y2="42" stroke="' + gold + '" stroke-width="1.6"/>');
    s.push('<polygon points="210,30 217,52 210,46 203,52" fill="' + gold + '"/>');
    s.push('<circle cx="210" cy="42" r="0" fill="' + gold + '"/>');
    // the Kaaba glyph at the needle's head — nested squares, as on the seal
    s.push('<rect x="196" y="60" width="28" height="28" fill="none" stroke="' + gold + '" stroke-width="1"/>');
    s.push('<rect x="203" y="67" width="14" height="14" fill="none" stroke="' + gold + '" stroke-width="0.8"/>');
    s.push('<rect x="207.5" y="71.5" width="5" height="5" fill="' + gold + '"/>');
    s.push('</g>');

    // hub
    s.push('<circle cx="210" cy="210" r="4.5" fill="' + text + '"/>');
    s.push('<circle cx="210" cy="210" r="11" fill="none" stroke="' + rule + '" stroke-width="0.8"/>');

    // bearing figure, set in the middle like a plate number
    s.push('<text x="210" y="268" fill="' + text + '" font-family="Cormorant Garamond,serif"'
         + ' font-size="34" text-anchor="middle">' + state.bearingDeg.toFixed(1) + '°</text>');
    s.push('<text x="210" y="290" fill="' + faint + '" font-family="Jost,sans-serif" font-size="9"'
         + ' font-weight="300" letter-spacing="3.4" text-anchor="middle">QIBLA · TRUE</text>');

    s.push('</svg>');
    dialEl.innerHTML = s.join('');
  }

  function update(origin){
    state.origin = origin;
    state.bearingDeg = bearing(origin, KAABA);
    var km = distance(origin, KAABA);
    document.getElementById('rFrom').textContent = origin.name;
    document.getElementById('rBearing').textContent = state.bearingDeg.toFixed(1) + '°';
    document.getElementById('rDistance').textContent = Math.round(km).toLocaleString();
    renderInstrument();
  }
/* ── location opt-in ───────────────────────────────────────────────── */
  var geoBtn = document.getElementById('geoBtn'), geoNote = document.getElementById('geoNote');
  geoBtn.addEventListener('click', function(){
    if (!navigator.geolocation){
      geoNote.textContent = 'This browser will not share a location. Atlanta is still shown.';
      return;
    }
    geoBtn.disabled = true; geoBtn.textContent = 'Locating…';
    navigator.geolocation.getCurrentPosition(function(pos){
      var la = pos.coords.latitude, lo = pos.coords.longitude;
      update({ lat: la, lon: lo,
               name: Math.abs(la).toFixed(4) + '°' + (la >= 0 ? 'N' : 'S') + '  ·  '
                   + Math.abs(lo).toFixed(4) + '°' + (lo >= 0 ? 'E' : 'W') });
      geoBtn.textContent = 'Located'; geoNote.textContent = 'Read from your device. It stays in this browser.';
    }, function(){
      geoBtn.disabled = false; geoBtn.textContent = 'Use my location';
      geoNote.textContent = 'Location was declined or unavailable. Atlanta is still shown.';
    }, { timeout: 10000 });
  });

  /* ── notify ────────────────────────────────────────────────────────── */
  var notify = document.getElementById('notify');
  if (notify) notify.addEventListener('submit', function(e){
    e.preventDefault();
    var msg = document.getElementById('notifyMsg');
    if (msg) msg.textContent = 'Added — you’ll hear from us on the drop date.';
    this.reset();
  });
/* ── the globe ─────────────────────────────────────────────────────────
     Scroll turns the world from where you are round to Makkah, and the
     great-circle line draws itself in as it comes. One gesture, one idea. */
  var G = { ok:false, arcs:[], mk:null,
            reduce: window.matchMedia('(prefers-reduced-motion: reduce)').matches, rotFrom:0, rotTo:0, arc:null, arcCount:0, group:null,
            renderer:null, scene:null, cam:null, host:null, target:0, eased:0 };

  function v3(lat, lon, r){
    var ph = (90 - lat) * Math.PI / 180, th = (lon + 180) * Math.PI / 180;
    return new THREE.Vector3(-(r * Math.sin(ph) * Math.cos(th)),
                               r * Math.cos(ph),
                               r * Math.sin(ph) * Math.sin(th));
  }
  function facing(lat, lon){ var v = v3(lat, lon, 1); return -Math.atan2(v.x, v.z); }

  function buildGlobe(){
    var host = document.getElementById('globe');
    if (!host || !window.THREE) return false;
    var gold = css('--accent') || '#C8A040', rule = css('--rule-strong') || '#3A3020';
    try { G.renderer = new THREE.WebGLRenderer({ antialias:true, alpha:true }); }
    catch(e){ return false; }

    var size = host.clientWidth || 420;
    G.renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    G.renderer.setSize(size, size, false);
    host.appendChild(G.renderer.domElement);

    G.scene = new THREE.Scene();
    G.cam = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
    G.cam.position.set(0, 0, 3.55);
    G.group = new THREE.Group();
    G.group.rotation.x = 0.22;
    G.scene.add(G.group);

    // point field
    var pts = [];
    for (var la = -84; la <= 84; la += 5)
      for (var lo = -180; lo < 180; lo += 5){
        var v = v3(la, lo, 1); pts.push(v.x, v.y, v.z);
      }
    var pg = new THREE.BufferGeometry();
    pg.setAttribute('position', new THREE.Float32BufferAttribute(pts, 3));
    G.group.add(new THREE.Points(pg, new THREE.PointsMaterial({
      color:new THREE.Color(gold), size:0.017, transparent:true, opacity:0.72,
      sizeAttenuation:true })));

    // graticule
    var lm = new THREE.LineBasicMaterial({ color:new THREE.Color(gold), transparent:true, opacity:0.28 });
    function ring(fn){
      var a = [];
      for (var t = 0; t <= 360; t += 3){ var v = fn(t); a.push(v.x, v.y, v.z); }
      var g = new THREE.BufferGeometry();
      g.setAttribute('position', new THREE.Float32BufferAttribute(a, 3));
      G.group.add(new THREE.Line(g, lm));
    }
    [-60,-30,0,30,60].forEach(function(la){ ring(function(t){ return v3(la, t - 180, 1.002); }); });
    for (var lo2 = 0; lo2 < 180; lo2 += 30){
      (function(L){ ring(function(t){ return v3(t <= 180 ? t - 90 : 270 - t, t <= 180 ? L : L + 180, 1.002); }); })(lo2);
    }

    // the line to Makkah, lifted into an arc so it reads against the sphere
    var A = v3(ATL.lat, ATL.lon, 1).normalize(), B = v3(KAABA.lat, KAABA.lon, 1).normalize();
    var ang = Math.acos(Math.min(1, Math.max(-1, A.dot(B)))), seg = 160, arr = [];
    for (var i = 0; i <= seg; i++){
      var t = i / seg,
          s1 = Math.sin((1 - t) * ang) / Math.sin(ang),
          s2 = Math.sin(t * ang) / Math.sin(ang),
          v = new THREE.Vector3(A.x*s1 + B.x*s2, A.y*s1 + B.y*s2, A.z*s1 + B.z*s2).normalize();
      v.multiplyScalar(1 + 0.16 * Math.sin(Math.PI * t));
      arr.push(v.x, v.y, v.z);
    }
    G.arcCount = seg + 1;
    G.arcs = [];
    [[1.000, 1.00, 2], [1.006, 0.34, 1], [0.994, 0.34, 1]].forEach(function(cfg){
      var sc = cfg[0], a2 = [];
      for (var k = 0; k < arr.length; k += 3) a2.push(arr[k]*sc, arr[k+1]*sc, arr[k+2]*sc);
      var g2 = new THREE.BufferGeometry();
      g2.setAttribute('position', new THREE.Float32BufferAttribute(a2, 3));
      var ln = new THREE.Line(g2, new THREE.LineBasicMaterial({
        color:new THREE.Color(gold), transparent:true, opacity:cfg[1],
        blending: cfg[1] < 1 ? THREE.AdditiveBlending : THREE.NormalBlending }));
      ln.geometry.setDrawRange(0, 2);
      G.arcs.push(ln); G.group.add(ln);
    });

    // Makkah: the nested-square Kaaba glyph, flattened onto the sphere
    var mk = v3(KAABA.lat, KAABA.lon, 1.02), mg = new THREE.Group();
    [0.055, 0.031].forEach(function(r, n){
      var e = new THREE.Mesh(new THREE.RingGeometry(r * 0.96, r, 4),
                new THREE.MeshBasicMaterial({ color:new THREE.Color(gold), side:THREE.DoubleSide,
                                              transparent:true, opacity: n ? 0.9 : 0.65 }));
      mg.add(e);
    });
    mg.add(new THREE.Mesh(new THREE.SphereGeometry(0.016, 12, 12),
             new THREE.MeshBasicMaterial({ color:new THREE.Color(gold) })));
    mg.position.copy(mk); mg.lookAt(0, 0, 0); mg.rotation.z = Math.PI / 4;
    G.group.add(mg); G.mk = mg;

    // origin pip
    var op = v3(ATL.lat, ATL.lon, 1.015);
    var od = new THREE.Mesh(new THREE.SphereGeometry(0.012, 10, 10),
               new THREE.MeshBasicMaterial({ color:new THREE.Color(gold), transparent:true, opacity:0.75 }));
    od.position.copy(op); G.group.add(od);

    // lit rim: a back-facing shell in additive gold reads as atmosphere
    var atmo = new THREE.Mesh(new THREE.SphereGeometry(1.055, 48, 48),
      new THREE.MeshBasicMaterial({ color:new THREE.Color(gold), transparent:true, opacity:0.055,
                                    side:THREE.BackSide, blending:THREE.AdditiveBlending }));
    G.scene.add(atmo);

    // the seal ring: screen-facing, does not spin with the globe
    [1.16, 1.115].forEach(function(r, n){
      var rg = new THREE.Mesh(new THREE.RingGeometry(r - (n ? 0.004 : 0.010), r, 128),
        new THREE.MeshBasicMaterial({ color:new THREE.Color(gold), side:THREE.DoubleSide,
                                      transparent:true, opacity: n ? 0.25 : 0.6 }));
      G.scene.add(rg);
    });

    G.host = host;
    G.rotFrom = facing(ATL.lat, ATL.lon);
    G.rotTo   = facing(KAABA.lat, KAABA.lon);
    var d = ((G.rotTo - G.rotFrom + Math.PI) % (2 * Math.PI)) - Math.PI;
    G.rotTo = G.rotFrom + d;                       // always take the short way round
    G.group.rotation.y = G.rotFrom;
    G.ok = true;
    return true;
  }

  function scrollProgress(){
    var sec = document.getElementById('qibla');
    if (!sec) return 0;
    var r = sec.getBoundingClientRect(), vh = innerHeight || 800;
    return Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (vh * 0.55 + r.height * 0.5)));
  }

  function tickGlobe(){
    if (!G.ok) return;
    G.target = scrollProgress();
    G.eased += (G.target - G.eased) * 0.085;              // smooth the scrub
    var e = G.eased < 0.5 ? 2*G.eased*G.eased : 1 - Math.pow(-2*G.eased + 2, 2) / 2;
    G.group.rotation.y = G.rotFrom + (G.rotTo - G.rotFrom) * e;
    G.group.rotation.x = 0.22 - 0.12 * e;
    var drawn = Math.max(2, Math.floor(G.arcCount * Math.min(1, e * 1.15)));
    G.arcs.forEach(function(l){ l.geometry.setDrawRange(0, drawn); });
    if (G.mk && !G.reduce){
      var t = performance.now() * 0.0016;
      G.mk.scale.setScalar(1 + 0.10 * Math.sin(t) * e);
    }
    G.renderer.render(G.scene, G.cam);
    var hint = document.getElementById('stageHint');
    if (hint) hint.setAttribute('data-off', G.eased > 0.35 ? '1' : '0');
    requestAnimationFrame(tickGlobe);
  }

  function sizeGlobe(){
    if (!G.ok) return;
    var w = G.host.clientWidth || 420;
    G.renderer.setSize(w, w, false);
    G.cam.aspect = 1; G.cam.updateProjectionMatrix();
  }

  function renderInstrument(){
    if (G.ok){ G.renderer.render(G.scene, G.cam); return; }
    var d = document.getElementById('dial');
    if (d && !d.hidden) drawDial();
  }

  if (!buildGlobe()){
    var gl = document.getElementById('globe'), dl = document.getElementById('dial'),
        hn = document.getElementById('stageHint');
    if (gl) gl.remove();
    if (hn) hn.remove();
    if (dl) dl.hidden = false;
    drawDial();
  } else {
    addEventListener('resize', sizeGlobe, { passive:true });
    requestAnimationFrame(tickGlobe);
  }

  update(ATL);
})();
